import React from "react";
import {
  IonCard,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonBadge,
  IonAvatar,
  IonItem,
} from "@ionic/react";
import { ReactComponent as AvatarImg } from "../../../assets/avatar.svg";
import { useDispatch } from "react-redux";
import { FormattedMessage } from "react-intl";
import { getFullName, getAgeByDate } from "../../../components/util/helpers";
import { saveChanges, loadRecord } from "../patientSlice";
import { Img } from "react-image";
import Resizer from "react-image-file-resizer";

const Personal = (props) => {
  const { activePatient } = props;
  const dispatch = useDispatch();
  const statusData = [
    {
      value: 1,
      name: <FormattedMessage id="app.mobile.active" />,
      status: "success",
    },
    {
      value: 2,
      name: <FormattedMessage id="app.mobile.not_active" />,
      status: "danger",
    },
    {
      value: 3,
      name: <FormattedMessage id="app.mobile.candidate" />,
      status: "light",
    },
    {
      value: 4,
      name: <FormattedMessage id="app.mobile.pre" />,
      status: "warning",
    },
  ];

  const status =
    activePatient && activePatient.status_id
      ? statusData[activePatient.status_id - 1]["status"]
      : null;
  const statusName =
    activePatient && activePatient.status_id
      ? statusData[activePatient.status_id - 1]["name"]
      : "";

  const employeeAge =
    activePatient && activePatient.birthday
      ? getAgeByDate(activePatient.birthday)
      : null;
  const arr = [getFullName(activePatient.surename, activePatient.first_name)];
  if (employeeAge) {
    arr.push(employeeAge);
  }
  const truncate = (input, num) =>
    input.length > num ? `${input.substring(0, num)}...` : input;
  const name = activePatient ? truncate(arr.join(", "), 24) : "";

  const onChange = async (f) => {
    const file = Object.assign(f);
    const image = await resizeFile(file);
    const params = {
      patient: { id: activePatient.id, avatar_url: image },
      branchId: activePatient.branch_id,
    };
    const patientParams = {
      id: activePatient.id,
      branchId: activePatient.branch_id,
      admin: false,
      patientId: activePatient.id,
    };
    const action = await dispatch(saveChanges(params));
    if (!action.error) {
      dispatch(loadRecord(patientParams));
    }
  };

  const resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        200,
        200,
        "JPEG",
        100,
        0,
        (url) => {
          resolve(url);
        },
        "base64"
      );
    });

  return (
    <IonCard>
      <IonItem lines="none" style={{ marginBottom: "-40px", zIndex: 999 }}>
        <IonAvatar
          slot="end"
          style={{ width: "100px", height: "100px" }}
          onClick={() => document.getElementById("getFile").click()}
        >
          <input
            type="file"
            accept="image/*"
            onChange={(ev) => onChange(ev.target.files[0])}
            id="getFile"
            style={{ display: "none" }}
          />
          <Img
            src={[activePatient.avatar_url]}
            unloader={<AvatarImg style={{ borderRadius: "50%" }} />}
          />
        </IonAvatar>
      </IonItem>
      <IonCardHeader>
        <IonCardSubtitle style={{ zIndex: "9999", width: "100px" }}>
          {<IonBadge color={status}>{statusName}</IonBadge>}
        </IonCardSubtitle>
        <IonCardTitle>{name}</IonCardTitle>
      </IonCardHeader>
    </IonCard>
  );
};

export default Personal;
